import rsc from './lco.rsc'
import participant from './lco.participant'
import admin from './lco.admin'

class Lco {
  constructor () {
    this.rsc = rsc
    this.participant = participant
    this.admin = admin
  }
}

export default new Lco()
